module.exports = __webpack_public_path__ + "media/images/payment/logo_lawson-f228f2cc16906c55d202973c925dc33c.gif";